"use client";
import {
  datePickerFormatJP,
  DEFAULT_CHECKIN_DATE,
  DEFAULT_CHECKOUT_DATE,
} from "@/constants";
import { cn } from "@/lib/utils";
import { groupJapanAreas, cityAndHotelFuzzyFilter } from "@/utils";
import { getSearchRoomData } from "@/components/organisms/hotel-result/filter/utils";
import { useValidatedDates } from "@/hooks/useValidatedDates";
import * as React from "react";
import { useEffect, useState } from "react";
import { DateRange } from "react-day-picker";
import {
  CustomSearchAvailableProps,
  SearchAvailableRoomMobile,
} from "./SearchAvailableRoomMobile";
import useJapanAreasStore from "@/store/hooks/useGlobal";
import { useIsMobile } from "@/hooks/useIsMobile/useIsMobile";
import useSearchFormStore from "@/store/searchFormStore/searchFormStore";
import { HomePage, JapanHotel } from "@/types/generated";
import { format } from "date-fns/format";
import { useParams } from "next/navigation";
import { CustomSelect } from "@/components/atoms/dropdown";
import { Icon } from "@/components/atoms/icon";
import { DateRangePicker } from "@/components/atoms/date-range-picker";
export const PROMO_CODE = "promo-code-localStorage";

const PartnerSearchHotelMobile: React.FC<
  Omit<CustomSearchAvailableProps, "listOption"> & {
    isTopPage?: boolean;
    isMobile?: boolean;
    partnerData?: HomePage;
  }
> = ({ className, locale, partnerData, ...props }) => {
  const isMobile = useIsMobile();
  const { japanAreas, loading, allLocaleHotels } = useJapanAreasStore();
  const { configurations: searchAvailableRoom, formData } =
    useSearchFormStore();
  const params = useParams();
  const searchRoomData = getSearchRoomData(searchAvailableRoom, params);

  const { checkIn: validatedCheckIn, checkOut: validatedCheckOut } = useValidatedDates(
    formData?.checkIn,
    formData?.checkout
  );
  const { rooms_configurations, booking, ages_configurations, tripla_section } =
    searchRoomData || {};
  const { maximum_adults, maximum_child_age, maximum_children, maximum_rooms } =
    rooms_configurations ?? {};
  const {
    tripla_add_room_label,
    tripla_bed_label,
    tripla_room_adults_label,
    tripla_room_children_label,
    tripla_room_name_label,
    tripla_with_bed_label,
    tripla_without_bed_label,
  } = tripla_section ?? {};
  const { booking_button_text } = booking ?? {};
  const { ages_label, age_placeholder, single_child_label } =
    ages_configurations ?? {};
  const { configurations } = searchRoomData || {};
  const {
    checkin_label,
    checkout_label,
    promo_code_label,
    promo_code_placeholder,
  } = configurations ?? {};
  
  const [range, setRange] = useState<DateRange>({
    from: new Date(DEFAULT_CHECKIN_DATE),
    to: new Date(DEFAULT_CHECKOUT_DATE),
  });

  const { promo_code } = partnerData || {};

  const [searchAvailableRoomMobileModal, setSearchAvailableRoomMobileModal] =
    useState(false);
  if (searchAvailableRoomMobileModal) {
    /* no-op */
  }
  
  // Initialize range from formData on mount only
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setRange({
      from: validatedCheckIn,
      to: validatedCheckOut,
    });
  }, []); // Run only once on mount

  const listCityAndHotel = groupJapanAreas(
    japanAreas,
    allLocaleHotels as Record<string, JapanHotel[]> | null | undefined,
    undefined,
    "エリア",
    "ホテル",
  );

  if (!isMobile) {
    return null;
  }

  return (
    <div className="flex w-full flex-col gap-6 bg-[var(--fill-base-main)] pt-8">
      <div
        className={cn("flex w-full flex-col gap-6 px-4 py-6", className)}
        {...props}
      >
        <div className="flex w-full flex-col gap-3">
          <div className="relative flex flex-col gap-1">
            <div className="text-sm font-medium text-white">
              エリア名／ホテル名
            </div>
            <SearchAvailableRoomMobile
              locale={locale}
              promoCode={promo_code?.promo_code ?? undefined}
              trigger={
                <div>
                  <CustomSelect
                    value={formData?.hotelOrCity || ""}
                    isDisabled
                    onFocus={() => {
                      return;
                    }}
                    onMenuOpen={() =>
                      // setTimeout(() => setIsMenuOpen(true), 0)
                      {
                        return;
                      }
                    }
                    onMenuClose={() =>
                      // setTimeout(() => setIsMenuOpen(false), 0)
                      {
                        return;
                      }
                    }
                    placeholder={"エリア名／ホテル名を入力してください"}
                    onInputChange={() => {
                      return;
                    }}
                    className="w-full text-sm"
                    iconCustom={
                      <Icon className="scale-80" icon="location-pin" />
                    }
                    isLoading={loading}
                    filterOption={(option, inputValue) => {
                      return cityAndHotelFuzzyFilter(
                        { label: option.label, data: option.data },
                        inputValue,
                      );
                    }}
                  />
                </div>
              }
              listOption={listCityAndHotel}
              configurations={{
                checkinLabel: checkin_label ?? "",
                checkoutLabel: checkout_label ?? "",
                promoCodeLabel: promo_code_label ?? "",
                promoCodePlaceholder: promo_code_placeholder ?? "",
              }}
              roomsConfigurations={{
                adultLabel: tripla_room_adults_label ?? "",
                childrenLabel: tripla_room_children_label ?? "",
                addRoomButtonText: tripla_add_room_label ?? "",
                maximumAdults: maximum_adults ?? "",
                maximumChildAge: maximum_child_age ?? "",
                maximumChildren: maximum_children ?? "",
                maximumRooms: maximum_rooms ?? "",
                singleRoomLabel: tripla_room_name_label ?? "",
                bedLabel: tripla_bed_label ?? "",
                withBedLabel: tripla_with_bed_label ?? "",
                withoutBedLabel: tripla_without_bed_label ?? "",
              }}
              booking={{
                bookingButtonText: booking_button_text ?? "",
              }}
              agesConfigurations={{
                agesLabel: ages_label ?? "",
                agePlaceholder: age_placeholder ?? "",
                singleChildLabel: single_child_label ?? "",
              }}
            />
          </div>

          <div className="flex flex-col gap-1">
            <div className="text-sm font-medium text-white">
              {`${checkin_label || "チェックイン"}・${checkout_label || "チェックアウト"}`}
            </div>
            <SearchAvailableRoomMobile
              locale={locale}
              promoCode={promo_code?.promo_code ?? undefined}
              trigger={
                <div>
                  <DateRangePicker
                    range={range}
                    preventEvent
                    onChange={() => {
                      setSearchAvailableRoomMobileModal(true);
                    }}
                    onCancel={() => {
                      setSearchAvailableRoomMobileModal(true);
                    }}
                  >
                    <div className="flex w-full items-center rounded-[var(--radius-input-md)] bg-white px-4 py-3 text-sm font-normal">
                      <span className="w-43">
                        {range?.from
                          ? format(range.from, datePickerFormatJP)
                          : ""}
                      </span>
                      <span className="w-14 text-center">→</span>
                      <span className="w-43">
                        {range?.to ? format(range.to, datePickerFormatJP) : ""}
                      </span>
                    </div>
                  </DateRangePicker>
                </div>
              }
              listOption={listCityAndHotel}
              configurations={{
                checkinLabel: checkin_label ?? "",
                checkoutLabel: checkout_label ?? "",
                promoCodeLabel: promo_code_label ?? "",
                promoCodePlaceholder: promo_code_placeholder ?? "",
              }}
              roomsConfigurations={{
                adultLabel: tripla_room_adults_label ?? "",
                childrenLabel: tripla_room_children_label ?? "",
                addRoomButtonText: tripla_add_room_label ?? "",
                maximumAdults: maximum_adults ?? "",
                maximumChildAge: maximum_child_age ?? "",
                maximumChildren: maximum_children ?? "",
                maximumRooms: maximum_rooms ?? "",
                singleRoomLabel: tripla_room_name_label ?? "",
                bedLabel: tripla_bed_label ?? "",
                withBedLabel: tripla_with_bed_label ?? "",
                withoutBedLabel: tripla_without_bed_label ?? "",
              }}
              booking={{
                bookingButtonText: booking_button_text ?? "",
              }}
              agesConfigurations={{
                agesLabel: ages_label ?? "",
                agePlaceholder: age_placeholder ?? "",
                singleChildLabel: single_child_label ?? "",
              }}
            />
          </div>
          <SearchAvailableRoomMobile
            locale={locale}
            promoCode={promo_code?.promo_code ?? undefined}
            trigger={
              <div>
                <CustomSelect
                  value={formData?.hotelOrCity || ""}
                  isDisabled
                  onFocus={() => {
                    return;
                  }}
                  onMenuOpen={() =>
                    // setTimeout(() => setIsMenuOpen(true), 0)
                    {
                      return;
                    }
                  }
                  onMenuClose={() =>
                    // setTimeout(() => setIsMenuOpen(false), 0)
                    {
                      return;
                    }
                  }
                  placeholder={"エリア名／ホテル名を入力してください"}
                  onInputChange={() => {
                    return;
                  }}
                  className="w-full text-sm"
                  iconCustom={<Icon className="scale-80" icon="location-pin" />}
                  isLoading={loading}
                  filterOption={(option, inputValue) => {
                    return cityAndHotelFuzzyFilter(
                      { label: option.label, data: option.data },
                      inputValue,
                    );
                  }}
                />
              </div>
            }
            listOption={listCityAndHotel}
            configurations={{
              checkinLabel: checkin_label ?? "",
              checkoutLabel: checkout_label ?? "",
              promoCodeLabel: promo_code_label ?? "",
              promoCodePlaceholder: promo_code_placeholder ?? "",
            }}
            roomsConfigurations={{
              adultLabel: tripla_room_adults_label ?? "",
              childrenLabel: tripla_room_children_label ?? "",
              addRoomButtonText: tripla_add_room_label ?? "",
              maximumAdults: maximum_adults ?? "",
              maximumChildAge: maximum_child_age ?? "",
              maximumChildren: maximum_children ?? "",
              maximumRooms: maximum_rooms ?? "",
              singleRoomLabel: tripla_room_name_label ?? "",
              bedLabel: tripla_bed_label ?? "",
              withBedLabel: tripla_with_bed_label ?? "",
              withoutBedLabel: tripla_without_bed_label ?? "",
            }}
            booking={{
              bookingButtonText: booking_button_text ?? "",
            }}
            agesConfigurations={{
              agesLabel: ages_label ?? "",
              agePlaceholder: age_placeholder ?? "",
              singleChildLabel: single_child_label ?? "",
            }}
          />
        </div>

        <div className="flex flex-col gap-1">
          <div className="text-sm font-medium text-white">
            {`${checkin_label || "チェックイン"}・${checkout_label || "チェックアウト"}`}
          </div>
          <SearchAvailableRoomMobile
            locale={locale}
            promoCode={promo_code?.promo_code ?? undefined}
            trigger={
              <div>
                <DateRangePicker
                  range={range}
                  preventEvent
                  onChange={() => {
                    setSearchAvailableRoomMobileModal(true);
                  }}
                  onCancel={() => {
                    setSearchAvailableRoomMobileModal(true);
                  }}
                >
                  <div className="flex w-full items-center rounded-[var(--radius-input-md)] bg-white px-4 py-3 text-sm font-normal">
                    <span className="w-43">
                      {range?.from
                        ? format(range.from, datePickerFormatJP)
                        : ""}
                    </span>
                    <span className="w-14 text-center">→</span>
                    <span className="w-43">
                      {range?.to ? format(range.to, datePickerFormatJP) : ""}
                    </span>
                  </div>
                </DateRangePicker>
              </div>
            }
            listOption={listCityAndHotel}
            configurations={{
              checkinLabel: checkin_label ?? "",
              checkoutLabel: checkout_label ?? "",
              promoCodeLabel: promo_code_label ?? "",
              promoCodePlaceholder: promo_code_placeholder ?? "",
            }}
            roomsConfigurations={{
              adultLabel: tripla_room_adults_label ?? "",
              childrenLabel: tripla_room_children_label ?? "",
              addRoomButtonText: tripla_add_room_label ?? "",
              maximumAdults: maximum_adults ?? "",
              maximumChildAge: maximum_child_age ?? "",
              maximumChildren: maximum_children ?? "",
              maximumRooms: maximum_rooms ?? "",
              singleRoomLabel: tripla_room_name_label ?? "",
              bedLabel: tripla_bed_label ?? "",
              withBedLabel: tripla_with_bed_label ?? "",
              withoutBedLabel: tripla_without_bed_label ?? "",
            }}
            booking={{
              bookingButtonText: booking_button_text ?? "",
            }}
            agesConfigurations={{
              agesLabel: ages_label ?? "",
              agePlaceholder: age_placeholder ?? "",
              singleChildLabel: single_child_label ?? "",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export { PartnerSearchHotelMobile };
